module.exports = __webpack_public_path__ + "img/62.1de7e1ee.jpg";